import { FC } from "react";
import {
  MoveBatteryDistributionPreview,
} from "../../BatteryDistributionPreview/MoveBatteryDistributionPreview";
import useMoveVirtualBatteryContext from "../useMoveVirtualBatteryContext";

interface MoveVirtualBatteryStep3Params {

}

export const MoveVirtualBatteryStep3: FC<MoveVirtualBatteryStep3Params> = ({
  // nextStepCallback
}) => {
  const {
    selectedBatteryId,
    newPercentage,
  } = useMoveVirtualBatteryContext();

  return (
    <>
      <MoveBatteryDistributionPreview 
        newPercentage={newPercentage!} 
        selectedBatteryId={selectedBatteryId!}
      />
    </>
  );
};

export default MoveVirtualBatteryStep3;
